import { isModularBillingOrg } from "@intelligems/ig-types/dtos/organization-subscriptions";
import { type OrganizationSummaryDto } from "@intelligems/ig-types/dtos/organization-summaries";

/**
 * Whether an org belongs on the modular billing surface, derived from its
 * organization summary. Reads both subscription lanes because a legacy
 * obligation can hide in either. Prefer subscription-access `org.isModular`
 * when it has loaded; this answers the question without it.
 */
export const isModularOrganizationSummary = (
  org: OrganizationSummaryDto
): boolean =>
  isModularBillingOrg({
    billingRegime: org.billingRegime,
    subscriptions: [
      ...org.stripeSubscriptionSummaries.map(
        ({ catalogVersion, status, version }) => ({
          status,
          version: catalogVersion ?? version,
        })
      ),
      ...org.organizationSubscriptions.map(({ status, version }) => ({
        status,
        version,
      })),
    ],
  });
